import { clsx } from "clsx"
import { Loader2 } from "lucide-react"
import { twMerge } from "tailwind-merge"

// Not cn from @/lib/utils: that pulls in the formatters and the auth store, and modules with
// plain-function tests (IntegrationDataStatus) import Spinner.
const cn = (...classes: Parameters<typeof clsx>) => twMerge(clsx(classes))

const sizes = {
  "2xs": "size-2.5",
  xs: "size-3",
  sm: "size-3.5",
  default: "size-4",
  md: "size-5",
  lg: "size-6",
  xl: "size-8",
} as const

/**
 * The one loading spinner. Inline next to text or inside a Button (prefer Button's `loading`);
 * for a whole page or section use LoadingState.
 */
function Spinner({
  className,
  size = "default",
  label,
  ...props
}: Omit<React.ComponentProps<"svg">, "ref"> & {
  size?: keyof typeof sizes
  /** Read out to screen readers; without it the spinner is decorative. */
  label?: string
}) {
  return (
    <Loader2
      data-slot="spinner"
      role={label ? "status" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn("shrink-0 animate-spin", sizes[size], className)}
      {...props}
    />
  )
}

export { Spinner }
